// 用于获取登录后储存的登录者信息
const loginInfo = () =>{
    const data = sessionStorage.getItem('loginInfo');
    return JSON.parse(data);
};
// 获取本地储存中的数据
export default (name) =>{
  const data = sessionStorage.getItem(name);
  if (typeof(data) === 'string') {
    return JSON.parse(data);
  } else {
    return {
      type: 'error',
      msg: '这不是一个对象'
    };
  }
};



// WEBPACK FOOTER //
// ./src/static/js/storeSaveData.js